import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { firstValueFrom } from 'rxjs';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrls: ['./marketplace-wallet-page.component.scss'],
})
export class MarketplaceWalletPageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private rewardsWalletService: RewardsWalletService,
    
  ) {}
  id: string;
  screenSize = ScreenType;
  private navigationService = inject(NavigationService);

  ngOnInit() {
    this.navigationService.hideMobileNav();
    this.id = this.route.snapshot.paramMap.get('id') || '0';
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }
  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
